import { Component, Input, OnInit } from '@angular/core';
import { NgStyle, NgFor } from '@angular/common';

@Component({
    selector: 'app-info-entregas-visita',
    templateUrl: './info-entregas-visita.component.html',
    styleUrls: ['./info-entregas-visita.component.css'],
    standalone: true,
    imports: [NgStyle, NgFor]
})
export class InfoEntregasVisitaComponent implements OnInit{
  @Input() roteiro: any;
  
  informacoesStatus = [];  

  ngOnInit() {
   this.iniciaInformacoesStatus();
  }

  iniciaInformacoesStatus(){
    this.informacoesStatus = [
      { titulo: 'Entregues', valor: this.roteiro.totalClienteEntregue },
      { titulo: 'Recusados', valor: this.roteiro.totalClienteRecusado },
      { titulo: 'Em análise', valor: this.roteiro.totalClienteEmAnalise },
      { titulo: 'Não visitados', valor: this.roteiro.totalClienteNaoVisitado }
    ];
  }

}
